import { forwardRef, HTMLAttributes } from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cn } from './cn';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  asChild?: boolean;
  interactive?: boolean;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { asChild = false, interactive, className, ...rest },
  ref
) {
  const Comp: any = asChild ? Slot : 'div';
  return (
    <Comp
      ref={ref}
      data-tss-ui=""
      data-interactive={interactive || undefined}
      className={cn('tss-card', className)}
      {...rest}
    />
  );
});
